import React from 'react'
import {
  Progress,
  Icon,
  Tag,
  message,
  Modal,
  Button,
  Select,
  Skeleton,
  Empty,
} from 'antd'

import prettysize from '../../../../utils'
import CloudFlyerAPI from '../../../../api/CloudFlyerAPI'

import './styles.scss'

class ServicesUsage extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { error, loading, data } = this.props
    console.log(data);

    const emptyPanel = (
      <div className="empty-panel">
        <Empty />
      </div>
    )
    const errorPanel = (
      <div className="error-panel">
        <h1>
          <Icon type="frown" />
          <span> Could not load data.</span>
        </h1>
      </div>
    )
    const loadingPanel = (
      <Skeleton title={false} paragraph={{ rows: 5, width: '100%' }} active />
    )

    const servicesUsagePanel = (
      <div className="services-usage-panel">
        <h2 className="title">Services Usage</h2>
        <div className="services">
          {data.map(s => (
            <Service
              key={s.name}
              name={s.name}
              num={s.num}
              numOf={s.numOf}
              percent={s.percent}
            />
          ))}
        </div>
      </div>
    )

    let panel

    if (error) panel = errorPanel
    else if (loading) panel = loadingPanel
    else if (!data.length) panel = emptyPanel
    else panel = servicesUsagePanel

    return <div className="services-usage">{panel}</div>
  }
}

const Service = ({ name, num, numOf, percent }) => (
  <div className="service">
    <div className="service-header">
      <h3>{name}</h3>
      <p>
        {numOf !== -1 ? (
          <>
            <span className="number">{prettysize(num)}</span> of{' '}
            <span className="number-of">{prettysize(numOf)}</span>
          </>
        ) : (
          <span className="number">{prettysize(num)}</span>
        )}
      </p>
    </div>
    <Progress percent={percent} showInfo={false} />
  </div>
)

export default ServicesUsage
